import { render, staticRenderFns } from "./ActualityComposer.vue?vue&type=template&id=4e5f23ea&scoped=true&"
import script from "./ActualityComposer.vue?vue&type=script&lang=js&"
export * from "./ActualityComposer.vue?vue&type=script&lang=js&"
import style0 from "./ActualityComposer.vue?vue&type=style&index=0&id=4e5f23ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f23ea",
  null
  
)

export default component.exports